export const productReviewsSelector = state => (state.administration.reports.productReviews.data.pagedCollection);
export const productReviewTotalPages = state => (state.administration.reports.productReviews.data.totalPages);
